<template>
  <span>
    {{ name }}
  </span>
</template>

<script>
  import { UsersService } from '@administration/services/UsersService';
  export default {
    props: {
      id: {
        type: [Number, String],
        default: ''
      }
    },
    data() {
      return {
        users: ''
      }
    },
    computed: {
      name() {
        if(this.users) {
          const user = this.users.filter((user) =>  user.id  == this.id);
          return user.length ? user[0].name : null;
        }
        return null;
      }
    },
    created() {
      UsersService.getList().then(data => this.users = data.data)
    }
  }
</script>